import { render, staticRenderFns } from "./flg.vue?vue&type=template&id=42fb8a02&scoped=true"
import script from "./flg.vue?vue&type=script&lang=js"
export * from "./flg.vue?vue&type=script&lang=js"
import style0 from "./flg.vue?vue&type=style&index=0&id=42fb8a02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb8a02",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/flg.vue
// module id = s2Nn
// module chunks = 0